/**
 * Dutch translations for status enum values.
 * These are domain-wide labels that apply to batches, chemicals,
 * storage facilities, certifications, companies, etc.
 */
export const statusNl = {
  // Batch / workflow statuses
  approved: 'Goedgekeurd',
  pending_approval: 'In Afwachting van Goedkeuring',
  rejected: 'Afgewezen',
  in_transit: 'Onderweg',
  active: 'Actief',
  expired: 'Verlopen',
  needs_retest: 'Her-test Nodig',
  invalid: 'Ongeldig',
  delivered: 'Geleverd',

  // Generic / certification statuses
  pending: 'In Afwachting',
  draft: 'Concept',
  submitted: 'Ingediend',
  valid: 'Geldig',
  expiring_soon: 'Binnenkort Verlopen',
  revoked: 'Ingetrokken',

  // Company / user statuses
  enabled: 'Ingeschakeld',
  disabled: 'Uitgeschakeld',
  verified: 'Geverifieerd',
  unverified: 'Niet Geverifieerd',
  locked: 'Vergrendeld',

  // Storage facility statuses
  operational: 'Operationeel',
  closed: 'Gesloten',
  under_maintenance: 'In Onderhoud',

  // Fallback
  unknown: 'Onbekend',
} as const
